import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    syncInventory() {
        return axios.post(`${API_URL}/shopify/sync-inventory`, {}, { headers: authHeader() });
    },
    syncProduct(id) {
        return axios.post(`${API_URL}/shopify/sync-product/${id}`, {}, { headers: authHeader() });
    },
    syncCatalog() {
        return axios.post(`${API_URL}/shopify/sync-catalog`, {}, { headers: authHeader() });
    },
    catalogProducts() {
        return axios.get(`${API_URL}/shopify/catalog-products`, { headers: authHeader() });
    },
};
